module.exports = __webpack_public_path__ + "img/about-us.e335f87e.jpg";